
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import { PageLoading } from "@/components/ui/loading";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Aluminum from "./pages/Aluminum";
import AluminumProductDetail from "./pages/AluminumProductDetail";
import Iron from "./pages/Iron";
import IronProductDetail from "./pages/IronProductDetail";
import Wood from "./pages/Wood";
import WoodProductDetail from "./pages/WoodProductDetail";
import KitchenCabinets from "./pages/KitchenCabinets";
import StainlessSteel from "./pages/StainlessSteel";
import StainlessSteelProductDetail from "./pages/StainlessSteelProductDetail";
import Glass from "./pages/Glass";
import GlassProductDetail from "./pages/GlassProductDetail";
import ContactPage from "./pages/ContactPage";
import AboutUs from "./pages/AboutUs";
import ServicesPage from "./pages/ServicesPage";
import Marble from "./pages/Marble";
import MarbleProductDetail from "./pages/MarbleProductDetail";
import GalleryPage from "./pages/GalleryPage";
import ArticlesPage from "./pages/ArticlesPage";
import ArticleDetail from "./pages/ArticleDetail";
import AdminAuth from "./pages/AdminAuth";
import AdminDashboard from "./pages/AdminDashboard";

const queryClient = new QueryClient();

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // تأكد من تحميل التطبيق بالكامل
    window.onload = () => {
      setIsLoading(false);
    };

    // تأمين في حالة عدم استدعاء onload
    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    // إذا كان المتصفح قد حمل بالفعل
    if (document.readyState === "complete") {
      setIsLoading(false);
    }

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          {isLoading ? (
            <PageLoading />
          ) : (
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/aluminum" element={<Aluminum />} />
                <Route path="/aluminum/:slug" element={<AluminumProductDetail />} />
                <Route path="/iron" element={<Iron />} />
                <Route path="/iron/:slug" element={<IronProductDetail />} />
                <Route path="/wood" element={<Wood />} />
                <Route path="/wood/:slug" element={<WoodProductDetail />} />
                <Route path="/kitchen-cabinets" element={<KitchenCabinets />} />
                <Route path="/stainless-steel" element={<StainlessSteel />} />
                <Route path="/stainless-steel/:slug" element={<StainlessSteelProductDetail />} />
                <Route path="/glass" element={<Glass />} />
                <Route path="/glass/:slug" element={<GlassProductDetail />} />
                <Route path="/marble" element={<Marble />} />
                <Route path="/marble/:slug" element={<MarbleProductDetail />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/articles" element={<ArticlesPage />} />
                <Route path="/articles/:id" element={<ArticleDetail />} />
                <Route path="/admin/auth" element={<AdminAuth />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          )}
        </TooltipProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
};

export default App;
